(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/endpoints/draw.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/endpoints/draw.js');
"use strict";

const {
  socket,
  log
} = svs.core;
const {
  ApiProxy,
  http,
  featureToggle
} = svs.components.lbUtils.apiProxy;
const {
  cloudApiFeatureToggles
} = svs.components.lbUtils.cloudApi.cloudApiConstants;
const {
  products
} = svs.utils;
const {
  normalizeDrawForecast,
  normalizeDrawResult
} = svs.components.tipsen.store.helpers;
const {
  TWO_MINUTES
} = svs.components.tipsen.store.endpoints.constants.timeAsSeconds;
const {
  getDefinitionByProduct
} = svs.components.tipsen.engine.utils;
const {
  actions: drawSubscriptionActions
} = svs.components.tipsen.store.reducers.playerWager;
const logger = log.getLogger('store:api');
const resolveDrawForecastPath = _ref => {
  let {
    drawNumber,
    productId
  } = _ref;
  const productDrawName = products.getSpecificDrawName(productId);
  const drawForecastUrl = "/draw/1/".concat(productDrawName, "/draws/forecast/").concat(drawNumber);
  return drawForecastUrl;
};
const getDrawEndpoints = builder => ({
  getDrawForecastFetch: builder.query({
    query: _ref2 => {
      let {
        drawNumber,
        productId
      } = _ref2;
      return resolveDrawForecastPath({
        drawNumber,
        productId
      });
    },
    transformResponse: (res, meta, _ref3) => {
      let {
        productId
      } = _ref3;
      return normalizeDrawForecast(res.forecastResult, productId);
    },
    keepUnusedDataFor: TWO_MINUTES
  }),
  getDrawForecast: builder.query({
    query: _ref4 => {
      let {
        drawNumber,
        productId
      } = _ref4;
      return resolveDrawForecastPath({
        drawNumber,
        productId
      });
    },
    keepUnusedDataFor: TWO_MINUTES,
    onCacheEntryAdded: async (_ref5, _ref6) => {
      let {
        drawNumber,
        productId
      } = _ref5;
      let {
        updateCachedData,
        cacheDataLoaded,
        cacheEntryRemoved,
        dispatch
      } = _ref6;
      const context = {};
      const drawForecastUrl = resolveDrawForecastPath({
        drawNumber,
        productId
      });
      const onSocketUpdate = drawForecastMessage => {
        logger.info("[forecast]: Update, dId:".concat(drawNumber, " pId:").concat(productId));
        updateCachedData(draft => {
          if (drawForecastMessage) {
            Object.assign(draft, normalizeDrawForecast(drawForecastMessage.forecastResult, productId));
          }
        });
      };
      try {
        await cacheDataLoaded;
        dispatch(drawSubscriptionActions.addDrawForecastSubscription({
          productId,
          drawNumber
        }));
        logger.info("[forecast]: Subscribe, dId:".concat(drawNumber, " pId:").concat(productId));
        socket.subscribe(drawForecastUrl, onSocketUpdate, context, true, true, true);
        logger.debug('socket subscribed');
      } catch (err) {
        logger.info("[forecast]: cacheEntryRemoved resolved before cacheDataLoaded, dId:".concat(drawNumber, " pId:").concat(productId));
      }
      await cacheEntryRemoved;
      logger.debug('socket unsubscribed');
      logger.info("[forecast]: Unsubscribe, dId:".concat(drawNumber, " pId:").concat(productId));
      socket.unsubscribe(drawForecastUrl, onSocketUpdate);
      dispatch(drawSubscriptionActions.deleteDrawForecastSubscription({
        productId,
        drawNumber
      }));
    }
  }),
  getDrawResult: builder.query({
    queryFn: async _ref7 => {
      let {
        drawNumber,
        productId
      } = _ref7;
      const productDrawName = products.getSpecificDrawName(productId);
      const customHandler = http.get('/draw/1/:product/draws/:drawNumber/result', _ref8 => {
        let {
          data
        } = _ref8;
        return data;
      }, {
        config: {
          shouldUseCloud: async () => {
            const toggleName = cloudApiFeatureToggles[productDrawName.toUpperCase()];
            if (!toggleName) {
              return false;
            }
            return featureToggle(toggleName, {
              req: undefined
            });
          },
          allowedProducts: ['bomben'],
          cloudEndpointTemplate: '/v1/:product/draws/:drawNumber/result'
        }
      });
      const apiProxy = new ApiProxy([customHandler]);
      try {
        const cloudData = await apiProxy.fetch("/draw/1/".concat(productDrawName, "/draws/").concat(drawNumber, "/result"), {
          method: 'GET',
          req: undefined
        });
        return {
          data: normalizeDrawResult(cloudData.result)
        };
      } catch (err) {
        var _err$status, _err$details;
        return {
          error: {
            status: (_err$status = err.status) !== null && _err$status !== void 0 ? _err$status : 'FETCH_ERROR',
            data: (_err$details = err.details) !== null && _err$details !== void 0 ? _err$details : err.message
          }
        };
      }
    },
    keepUnusedDataFor: TWO_MINUTES,
    extraOptions: {
      maxRetries: 3
    }
  }),
  getDrawsResults: builder.query({
    queryFn: async _ref9 => {
      let {
        productId
      } = _ref9;
      const definition = getDefinitionByProduct(productId);
      const productDrawName = definition.loadDrawsApiPath;
      const customHandler = http.get('/draw/1/:product/draws/result', _ref0 => {
        let {
          data
        } = _ref0;
        return data;
      }, {
        config: {
          shouldUseCloud: async () => {
            const toggleName = cloudApiFeatureToggles[productDrawName.toUpperCase()];
            if (!toggleName) {
              return false;
            }
            return featureToggle(toggleName, {
              req: undefined
            });
          },
          allowedProducts: ['bomben'],
          cloudEndpointTemplate: '/v1/:product/draws/result'
        }
      });
      const apiProxy = new ApiProxy([customHandler]);
      try {
        const response = await apiProxy.fetch("/draw/1/".concat(productDrawName, "/draws/result"), {
          method: 'GET',
          req: undefined
        });
        response.results = (response.results || [response.result]).filter(Boolean);
        delete response.result;
        return response;
      } catch (err) {
        logger.error("Error fetching draws results for product ".concat(productDrawName, ": ").concat(err.message));
      }
    },
    keepUnusedDataFor: TWO_MINUTES
  })
});
setGlobal('svs.components.tipsen.store.endpoints.getDrawEndpoints', getDrawEndpoints);

 })(window);